import { render, staticRenderFns } from "./protected_badge.vue.js?vue&type=template&id=a4bb36b6&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./protected_badge.vue?vue&type=template&id=a4bb36b6&vue3"
import script from "./protected_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./protected_badge.vue?vue&type=script&lang=js&vue3"
export * from "./protected_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./protected_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports